'use strict';

export const IS_JEST = typeof globalThis.jest !== 'undefined' || process.env.NODE_ENV === 'test';
//# sourceMappingURL=platformChecker.js.map